import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { workflowItems } from "../../pages/workflow";
import { Main } from "./style";
import { ReactSVG } from "react-svg";
import { operationType } from "../../services/types";
import { PanelLeftOpen, PanelRightOpen, Workflow } from "lucide-react";

let timeoutId: any = 0;

export function Sidebar() {
   const [isMiniMenu, setIsMiniMenu] = React.useState<boolean>(true);
   const [isNoWrap, setIsNoWrap] = React.useState<boolean>(false);
   const [search, setSearch] = React.useState<string>('');
   const [categories, setCategories] = React.useState<{ name: string, ref: string, image: string, isToggle?: boolean }[]>([
      { name: 'Fetch Data', ref: 'fetch', image: 'images/fetch1.png', isToggle: true },
      { name: 'Process', ref: 'process', image: 'images/process1.png' },
      { name: 'Actions', ref: 'actions', image: 'images/actions1.png' },
      { name: 'Templates', ref: 'templates', image: 'images/templates1.png' },
   ]);
   const [items, setItems] = React.useState<{ name: string, isToggle: boolean, data: operationType[] }[]>([]);

   // ---
   React.useEffect(() => {
      const category = categories.find(category => category.isToggle)?.name;
      const filter = workflowItems.filter(item => item.category?.includes(category as string));

      setItems(Object.values(filter.reduce((acc, item) => { // @ts-ignore
         const subCategory: any = item.subCategory[category];
         if (subCategory && !item.isHide) { // @ts-ignore
            if (!acc[subCategory]) acc[subCategory] = { name: subCategory, isToggle: false, data: [] }; // @ts-ignore
            acc[subCategory].data.push(item);
         }
         return acc;
      }, {})));
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [categories]);

   // ---
   React.useEffect(() => {
      clearTimeout(timeoutId);
      setIsNoWrap(true);
      timeoutId = setTimeout(() => { setIsNoWrap(false) }, 500);
      return () => {
         clearTimeout(timeoutId);
      }
   }, [isMiniMenu]);

   // ---
   const onDragStart = (event: React.DragEvent<HTMLDivElement>, action: string) => {
      event.dataTransfer.setData('text/plain', categories.find(c => c.isToggle)?.name as string);
      event.dataTransfer.setData('application/reactflow', action);
      event.dataTransfer.effectAllowed = 'move';
   }

   // ---
   const categoryToggle = (name: string) => {
      setItems((items) =>
         items.map((item) => {
            if (item.name === name) return { ...item, isToggle: !item.isToggle };
            else return item;
         })
      );
   }

   // ---
   const filterWithSearch = React.useMemo(() => workflowItems.filter(item => !item.isHide && item.name.toLowerCase().includes(search.toLowerCase())), [search]);

   return (
      <Main className={isMiniMenu ? 'minimizeMenu' : ''}>
         <div className="logo">
            {!isMiniMenu ? <div className="title">
               <div className="icon">
                  <Workflow className="h-6 w-6 text-white" />
               </div>
               <div className="info">
                  <h4>Workflow Builder</h4>
                  <span>Design & Automate</span>
               </div>
            </div> : null}
            <div className="mini" onClick={() => setIsMiniMenu(isToggle => !isToggle)}>
               {isMiniMenu ? <PanelLeftOpen size="25px" /> : <PanelRightOpen size="25px" />}
            </div>
         </div>
         <div className="search">
            <FontAwesomeIcon icon={faSearch} onClick={_ => { if (isMiniMenu) setIsMiniMenu(false) }} />
            <input
               placeholder="Search Blocks"
               value={search}
               onChange={e => setSearch(e.target.value)}
               onClick={_ => { if (isMiniMenu) setIsMiniMenu(false) }}
            />
         </div>
         <div className="categories">{
            !search ? <>
               <ul>{
                  categories.map((item, index) => (
                     <li
                        key={item.name}
                        className={`${item.ref} ${item.isToggle ? 'active' : ''}`}
                        onClick={_ => {
                           setCategories(prev => prev.map((p, i) => ({ ...p, isToggle: i === index })));
                           if (isMiniMenu) setIsMiniMenu(false);
                        }}

                     >
                        <img src={item.image} alt="category" />
                        <span>{item.name}</span>
                     </li>
                  ))
               }</ul>
               <div className="blocks">
                  <div className="container">{
                     items.map(item => (
                        <div key={item.name} className={`items ${isNoWrap ? 'noWrap' : ''}`}>
                           <div className="top">
                              <h4>{item.name}</h4>
                              {item.data.length > 3 ? <span onClick={_ => categoryToggle(item.name)}>{item.isToggle ? 'Minimize' : 'View all'}</span> : null}
                           </div>
                           <div>{
                              item.data.slice(0, item.isToggle ? item.data.length : 3).map(block => (
                                 <div key={block.action} onDragStart={event => onDragStart(event, block.action)} draggable>
                                    <span style={{ backgroundColor: block.background || '#06b6d4' }}>{
                                       typeof block.icon === 'string' ? 
                                       (block.icon.endsWith('.png') || block.icon.endsWith('.jpg') 
                                          ? <img src={ block.icon } alt={block.name} style={{ width: '25px', height: '25px', objectFit: 'contain' }} /> 
                                          : <ReactSVG className="otherSvg" src={block.icon} />) 
                                          : <FontAwesomeIcon icon={block.icon} />}</span>
                                    <span>{block.name}</span>
                                 </div>
                              ))
                           }</div>
                        </div>
                     ))
                  }</div>
               </div>
            </> : <div className="items searchFilter"><div>{
               filterWithSearch.map(block => (
                  <div
                     key={block.action}
                     onDragStart={event => onDragStart(event, block.action)}
                     onDragEnd={_ => setSearch('')}
                     draggable
                  >
                     <span style={{ backgroundColor: block.background || '#06b6d4' }}>{typeof block.icon === 'string' ? (block.icon.endsWith('.png') || block.icon.endsWith('.jpg') ? <img src={block.icon} alt={block.name} style={{ width: '25px', height: '25px', objectFit: 'contain' }} /> : <ReactSVG className="otherSvg" src={block.icon} />) : <FontAwesomeIcon icon={block.icon} />}</span>
                     <span>{block.name}</span>
                  </div>
               ))
            }</div></div>
         } </div>
      </Main>
   );
}